<template>
	<div class="main-fn-body-secend-body" :class="{'main-fn-body-secend-body_en': $app.language}">
		<!-- 一个表格显示文件 -->
		<div class="main-fn-secend-up" :class="{'main-fn-secend-up-spys': $route.path == '/main/spys'}">
			<table class="main-fn-secend-up-table">
				<thead :class="{'thead_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680}">
					<tr>
						<th class="tr-id" id="main-fn-secend-up-table-th">{{ $t("number") }}</th>
						<th
							class="tr-filename"
							:class="{'tr-filename-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("filename") }}
						</th>
						<th
							class="tr-file-old"
							:class="{'tr-file-old-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("originalfilesize") }}
						</th>
						<th
							class="tr-file-new"
							:class="{'tr-file-new-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("compressedsize") }}
						</th>
						<th
							class="tr-fen-old"
							v-show="files[0].width || files[0].width == 0"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("originalfileresolution") }}
						</th>
						<th
							class="tr-fen-new"
							v-show="files[0].width || files[0].width == 0"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("compressedresolution") }}
						</th>
						<th
							class="tr-yasuolv"
							:class="{'tr-yasuolv-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("compressionratio") }}
						</th>
						<th
							class="tr-zhuangtai"
							:class="{'tr-zhuangtai-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("state") }}
						</th>
						<th
							class="tr-contral"
							:class="{'tr-contral-state2': !files[0].width && files[0].width != 0}"
							id="main-fn-secend-up-table-th"
						>
							{{ $t("operation") }}
						</th>
					</tr>
				</thead>
				<tbody :class="{'tbody_Full-secreen': $app.isFullScreen && $app.nowSeceen.width >= 1680}">
					<tr
						class="main-fn-secend-up-table-tr"
						:class="{'main-fn-secend-up-table-tr-onclick': i == nowTr ? true : false}"
						v-for="(file, i) in files"
						:key="i"
						@click="getFileState($event, file, i)"
					>
						<td class="tr-id">{{ i + 1 }}</td>
						<td class="tr-filename" :class="{'tr-filename-state2': !file.width && file.width != 0}">
							<div :title="`${file.name}${file.ext}`">
								<img :src="require('./img/main-fn-body-secend/' + imgText)" alt="" /><span>{{
									`${file.name}${file.ext}`
								}}</span>
							</div>
						</td>
						<td class="tr-file-old" :class="{'tr-file-old-state2': !file.width && file.width != 0}">
							{{ $util.traffic(file.size) }}
						</td>
						<td class="tr-file-new" :class="{'tr-file-new-state2': !file.width && file.width != 0}">
							{{ $util.traffic(file.outsize) || "-" }}
						</td>
						<td class="tr-fen-old" v-show="file.width || file.width == 0">
							{{ file.width == 0 ? "-" : `${Math.floor(file.width)}*${Math.floor(file.height)}` }}
						</td>
						<td class="tr-fen-new" v-show="file.width || file.width == 0">
							{{
								file.outwidth > 0
									? `${Math.floor(file.outwidth)}*${Math.floor(file.outheight)}`
									: "-"
							}}
						</td>
						<td class="tr-yasuolv" :class="{'tr-yasuolv-state2': !file.width && file.width != 0}">
							{{
								file.outsize ? `${$util.percent((file.size - file.outsize) / file.size, 10)}%` : "-"
							}}
						</td>
						<td
							v-if="file.state == 2 || file.state == 1"
							class="tr-zhuangtai"
							:class="{'tr-zhuangtai-state2': !file.width && file.width != 0}"
						>
							<i-rate
								:color="'#2C9AEE'"
								:bgColor="'#F2F2F2'"
								:width="'80rem'"
								:height="'4rem'"
								:value="file.progress"
								:radius="'2rem'"
							></i-rate>
						</td>
						<td
							v-else-if="file.state == 3"
							class="tr-zhuangtai"
							:class="[
								'tr-zhuangtai-state-success',
								{'tr-zhuangtai-state2': !file.width && file.width != 0},
							]"
							:title="state2tip[file.state]"
						>
							{{ states[file.state] }}
						</td>
						<td
							v-else-if="file.state == 0 || file.state == 4 || file.state == 5"
							class="tr-zhuangtai"
							:class="[
								{'tr-zhuangtai-state2': !file.width && file.width != 0},
								`tr-zhuangtai-state-failure`,
							]"
						>
							<p>{{ $t("cannotcompress") }}</p>
							<div class="tr-zhuangtai-state-failure-div1">
								<transition name="it-fade">
									<div id="tr-zhuangtai-state-failure-downdiv">
										{{ $t("reasonmaybe") }}<br />
										1.{{ $t("text005") }}<br />
										2.{{ $t("text006") }}<br />
										3.{{ $t("text007") }}<br />
										4.{{ $t("text008") }}
									</div>
								</transition>
							</div>
						</td>
						<td
							v-else-if="file.state == 6"
							class="tr-zhuangtai"
							:class="[
								{'tr-zhuangtai-state2': !file.width && file.width != 0},
								`tr-zhuangtai-state-limit`,
							]"
						>
							<div
								@click="
									[
										openLimitBody2(),
										gevt('VIP用户可压缩', '点击事件', nowCompressedFormat, 'None', 'None', 'None'),
										stateToLimitToShop(),
									]
								"
							></div>
						</td>
						<td
							class="tr-contral"
							@click.stop=""
							:class="{'tr-contral-state2': !file.width && file.width != 0}"
						>
							<div class="tr-contral-showfile" @click="show(file)"></div>
							<div
								class="tr-contral-removefile"
								@click="$hdapi.platform == 'WIN' || $app.isYsOver ? remove(file) : null"
							></div>
						</td>
					</tr>
					<!-- <div class="main-fn-secend-up-table-tbody-navline"></div> -->
				</tbody>
			</table>
		</div>
		<!-- 通用设置 -->
		<!-- ppt word pdf 通用 -->
		<div
			class="main-fn-secend-down"
			v-if="
				$route.path == '/main/wordys' ||
				$route.path == '/main/pptys' ||
				$route.path == '/main/pdfys'
			"
		>
			<!-- title -->
			<p class="main-fn-secend-down-title">{{ $t("generalsettings") }}</p>
			<!-- 设置按钮 -->
			<div class="main-fn-secend-down-main">
				<div class="main-fn-secend-down-main-div1">
					<span class="main-fn-secend-down-main-title">{{ $t("compressionsettings") }}</span>
					<input
						type="radio"
						id="suoxiao-first"
						v-model="options.compressLevel"
						:value="0"
						:name="radio0"
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="suoxiao-first"
						><span>{{ $t("shrinkfirst") }}</span></label
					>
					<input
						type="radio"
						id="normal-first"
						v-model="options.compressLevel"
						:value="2"
						:name="radio0"
						:disabled="!$app.isYsOver || !$app.isDrOver"
						v-if="isNormalStyle"
					/>
					<label class="normal-first-span" for="normal-first" v-if="isNormalStyle"
						><span>{{ $t("ordinarycompression") }}</span></label
					>
					<input
						type="radio"
						id="qinxi-first"
						v-model="options.compressLevel"
						:value="1"
						:name="radio0"
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="qinxi-first"
						><span>{{ $t("clarityfirst") }}</span></label
					>
				</div>
				<div v-if="shuchuStyle">
					<span class="main-fn-secend-down-main-title">{{ $t("outputformat") }}</span>
					<input
						type="radio"
						id="other-geshi"
						v-model="options.outputExt"
						:value="outputExt"
						:name="radio1"
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="other-geshi"
						><span>{{ shuchuStyle }}</span></label
					>
					<input
						type="radio"
						id="old-geshi"
						v-model="options.outputExt"
						value=""
						:name="radio1"
						:disabled="!$app.isYsOver || !$app.isDrOver"
					/>
					<label for="old-geshi"
						><span>{{ $t("formatunchang") }}</span></label
					>
				</div>
			</div>
		</div>
		<!-- video -->
		<div
			v-else-if="$route.path == '/main/spys'"
			:class="{'main-fn-secend-down-video_en': $app.language}"
		>
			<!-- left -->
			<div class="main-fn-secend-down" id="main-fn-secend-down-video_left">
				<!-- title -->
				<p class="main-fn-secend-down-title">{{ $t("generalsettings") }}</p>
				<!-- 设置按钮 -->
				<div class="main-fn-secend-down-main">
					<div class="main-fn-secend-down-main-div1">
						<span class="main-fn-secend-down-main-title">{{ $t("compressionsettings") }}</span>
						<input
							type="radio"
							id="suoxiao-first"
							v-model="options.compressLevel"
							:value="0"
							:name="radio0"
							:disabled="
								!$app.isYsOver ||
								!$app.isDrOver ||
								nowFile.is_video_bitrate ||
								nowFile.is_video_fps ||
								nowFile.is_music_bitrate ||
								nowFile.is_music_samplingrate ||
								nowFile.is_gx_resolution
							"
							:class="{
								disabled_label:
									nowFile.is_video_bitrate ||
									nowFile.is_video_fps ||
									nowFile.is_music_bitrate ||
									nowFile.is_music_samplingrate ||
									nowFile.is_gx_resolution,
							}"
						/>
						<label for="suoxiao-first"
							><span>{{ $t("shrinkfirst") }}</span></label
						>
						<input
							type="radio"
							id="qinxi-first"
							v-model="options.compressLevel"
							:value="1"
							:name="radio0"
							:disabled="
								!$app.isYsOver ||
								!$app.isDrOver ||
								nowFile.is_video_bitrate ||
								nowFile.is_video_fps ||
								nowFile.is_music_bitrate ||
								nowFile.is_music_samplingrate ||
								nowFile.is_gx_resolution
							"
							:class="{
								disabled_label:
									nowFile.is_video_bitrate ||
									nowFile.is_video_fps ||
									nowFile.is_music_bitrate ||
									nowFile.is_music_samplingrate ||
									nowFile.is_gx_resolution,
							}"
						/>
						<label for="qinxi-first"
							><span>{{ $t("clarityfirst") }}</span></label
						>
					</div>
					<div>
						<span class="main-fn-secend-down-main-title">{{ $t("outputformat") }}</span>
						<input
							type="radio"
							id="other-geshi"
							v-model="options.outputExt"
							:value="outputExt"
							:name="radio1"
							:disabled="!$app.isYsOver || !$app.isDrOver"
						/>
						<label for="other-geshi"
							><span>{{ shuchuStyle }}</span></label
						>
						<input
							type="radio"
							id="old-geshi"
							v-model="options.outputExt"
							value=""
							:name="radio1"
							:disabled="!$app.isYsOver || !$app.isDrOver"
						/>
						<label for="old-geshi"
							><span>{{ $t("formatunchang") }}</span></label
						>
					</div>
				</div>
			</div>
			<!-- right -->
			<div
				class="main-fn-secend-down main-fn-secend-down-main"
				:class="{'main-fn-secend-down-video_right-disabled': !$app.VIPlevel && !$app.language}"
				id="main-fn-secend-down-video_right"
			>
				<!-- title -->
				<div class="main-fn-secend-down-video_right-title">
					<p class="main-fn-secend-down-title">{{ $t("efficientcompression") }}</p>
					<input
						type="radio"
						v-model="options.global_application"
						id="global_set_true"
						:value="true"
						name="global_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!options.global_application"
					/>
					<label for="global_set_true" v-show="!options.global_application"
						><span>{{ $t("applytoallfiles") }}</span></label
					>
					<input
						type="radio"
						v-model="options.global_application"
						id="global_set_false"
						:value="false"
						name="global_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="options.global_application"
					/>
					<label id="set_false_label" for="global_set_false" v-show="options.global_application"
						><span>{{ $t("applytoallfiles") }}</span></label
					>
					<div
						class="main-fn-secend-down-video_right-title_vip"
						v-if="!$app.VIPlevel && !$app.language"
						@click="
							!$app.VIPlevel && !$app.language
								? [
										toVIP(nowCompressedFormat + '高效压缩限制'),
										gevt(
											'开通VIP即可使用',
											'点击事件',
											nowCompressedFormat,
											'None',
											'None',
											'None'
										),
								  ]
								: null
						"
					>
						<img src="./img/main-fn-body-secend/icon_kt_vip01@2x.png" alt="" />
						<span>{{ $t("openviptouse") }}</span>
					</div>
				</div>
				<!-- 设置按钮 -->
				<div class="main-fn-secend-down-video_right-setbutton_1">
					<p>{{ $t("videosettings") }}</p>
					<input
						type="radio"
						v-model="nowFile.is_gx_resolution"
						:value="true"
						id="resolution_set_true"
						name="resolution_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_gx_resolution"
					/>
					<label for="resolution_set_true" v-show="!nowFile.is_gx_resolution"
						><span>{{ $t("zoomratio") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_gx_resolution"
						:value="false"
						id="resolution_set_false"
						name="resolution_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_gx_resolution"
					/>
					<label id="set_false_label" for="resolution_set_false" v-show="nowFile.is_gx_resolution"
						><span>{{ $t("zoomratio") }}</span></label
					>
					<input
						type="text"
						:value="now_gx_aspect_ratio"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxAaspectRatioReturn"
						ref="nowGxAspectRatio"
					/><span>%</span>
					<p>{{ $t("resolvingpower") }}</p>
					<input
						type="text"
						:value="now_gx_width"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxWidthReturn"
						ref="nowGxWidth"
					/><span>x</span
					><input
						type="text"
						:value="now_gx_height"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxHeightReturn"
						ref="nowGxHeight"
					/>
				</div>
				<div class="main-fn-secend-down-video_right-setbutton_2">
					<!-- TODO: 比特率单选框 -->
					<input
						type="radio"
						v-model="nowFile.is_video_bitrate"
						:value="true"
						name="video_bitrate_set"
						id="video_bitrate_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_video_bitrate"
					/>
					<label for="video_bitrate_set_true" v-show="!nowFile.is_video_bitrate"
						><span>{{ $t("bitrate") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_video_bitrate"
						:value="false"
						name="video_bitrate_set"
						id="video_bitrate_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_video_bitrate"
					/>
					<label
						id="set_false_label"
						for="video_bitrate_set_false"
						v-show="nowFile.is_video_bitrate"
						><span>{{ $t("bitrate") }}</span></label
					>
					<!-- TODO:比特率下拉框 -->
					<i-select
						@input="input"
						:str="'video_bitrate'"
						:opts="gxSelectArray.video_bitrate_label"
						:valueArray="gxSelectArray.video_bitrate_value"
						:value="nowFile.video_bitrate"
						:enable="
							!(
								!$app.isYsOver ||
								!$app.isDrOver ||
								(!$app.VIPlevel && !$app.language) ||
								!nowFile.is_video_bitrate
							)
						"
						@focus="clear_globalApplication_time"
						@blur="create_globalApplication_time"
					>
					</i-select>
					<!--TODO: 帧率单选框 -->
					<input
						type="radio"
						v-model="nowFile.is_video_fps"
						:value="true"
						name="video_fps_set"
						id="video_fps_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_video_fps"
					/>
					<label for="video_fps_set_true" v-show="!nowFile.is_video_fps"
						><span>{{ $t("frameratefps") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_video_fps"
						:value="false"
						name="video_fps_set"
						id="video_fps_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_video_fps"
					/>
					<label id="set_false_label" for="video_fps_set_false" v-show="nowFile.is_video_fps"
						><span>{{ $t("frameratefps") }}</span></label
					>
					<!--TODO: 帧率下拉框 -->
					<i-select
						@input="input"
						:str="'video_fps'"
						:opts="gxSelectArray.video_fps_label"
						:valueArray="gxSelectArray.video_fps_value"
						:value="nowFile.video_fps"
						:enable="
							!(
								!$app.isYsOver ||
								!$app.isDrOver ||
								(!$app.VIPlevel && !$app.language) ||
								!nowFile.is_video_fps
							)
						"
						@focus="clear_globalApplication_time"
						@blur="create_globalApplication_time"
					>
					</i-select>
				</div>
				<div class="main-fn-secend-down-video_right-setbutton_3">
					<p>{{ $t("audiosettings") }}</p>
					<!--TODO: 比特率单选框 -->
					<input
						type="radio"
						v-model="nowFile.is_music_bitrate"
						:value="true"
						name="music_bitrate_set"
						id="music_bitrate_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_music_bitrate"
					/>
					<label for="music_bitrate_set_false" v-show="!nowFile.is_music_bitrate"
						><span>{{ $t("bitrate") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_music_bitrate"
						:value="false"
						name="music_bitrate_set"
						id="music_bitrate_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_music_bitrate"
					/>
					<label id="set_false_label" for="music_bitrate_set_true" v-show="nowFile.is_music_bitrate"
						><span>{{ $t("bitrate") }}</span></label
					>
					<!--TODO: 比特率下拉框 -->
					<i-select
						@input="input"
						:str="'music_bitrate'"
						:opts="gxSelectArray.music_bitrate_label"
						:valueArray="gxSelectArray.music_bitrate_value"
						:value="nowFile.music_bitrate"
						:enable="
							!(
								!$app.isYsOver ||
								!$app.isDrOver ||
								(!$app.VIPlevel && !$app.language) ||
								!nowFile.is_music_bitrate
							)
						"
						@focus="clear_globalApplication_time"
						@blur="create_globalApplication_time"
					>
					</i-select>
					<!--TODO: 采样率单选框 -->
					<input
						type="radio"
						v-model="nowFile.is_music_samplingrate"
						:value="true"
						name="music_samplingrate_set"
						id="music_samplingrate_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_music_samplingrate"
					/>
					<label for="music_samplingrate_set_false" v-show="!nowFile.is_music_samplingrate"
						><span>{{ $t("samplingratekhz") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_music_samplingrate"
						:value="false"
						name="music_samplingrate_set"
						id="music_samplingrate_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_music_samplingrate"
					/>
					<label
						id="set_false_label"
						for="music_samplingrate_set_true"
						v-show="nowFile.is_music_samplingrate"
						><span>{{ $t("samplingratekhz") }}</span></label
					>
					<!-- 采样率下拉框 -->
					<i-select
						@input="input"
						:str="'music_samplingrate'"
						:opts="gxSelectArray.music_samplingrate_label"
						:valueArray="gxSelectArray.music_samplingrate_value"
						:value="nowFile.music_samplingrate"
						:enable="
							!(
								!$app.isYsOver ||
								!$app.isDrOver ||
								(!$app.VIPlevel && !$app.language) ||
								!nowFile.is_music_samplingrate
							)
						"
						@focus="clear_globalApplication_time"
						@blur="create_globalApplication_time"
					>
					</i-select>
				</div>
			</div>
		</div>
		<!-- img -->
		<div
			v-else-if="$route.path == '/main/tpys'"
			:class="{'main-fn-secend-down-img_en': $app.language}"
		>
			<!-- left -->
			<div class="main-fn-secend-down" id="main-fn-secend-down-img_left">
				<!-- title -->
				<p class="main-fn-secend-down-title">{{ $t("generalsettings") }}</p>
				<!-- 设置按钮 -->
				<div class="main-fn-secend-down-main">
					<div class="main-fn-secend-down-main-div1">
						<span class="main-fn-secend-down-main-title">{{ $t("compressionsettings") }}</span>
						<input
							type="radio"
							id="suoxiao-first"
							v-model="options.compressLevel"
							:value="50"
							:name="radio0"
							:disabled="!$app.isYsOver || !$app.isDrOver || nowFile.is_gx_quality"
							:class="{disabled_label: nowFile.is_gx_quality}"
						/>
						<label for="suoxiao-first"
							><span>{{ $t("shrinkfirst") }}</span></label
						>
						<input
							type="radio"
							id="normal-first"
							v-model="options.compressLevel"
							:value="70"
							:name="radio0"
							:disabled="!$app.isYsOver || !$app.isDrOver || nowFile.is_gx_quality"
							:class="{disabled_label: nowFile.is_gx_quality}"
						/>
						<label class="normal-first-span" for="normal-first"
							><span>{{ $t("ordinarycompression") }}</span></label
						>
						<input
							type="radio"
							id="qinxi-first"
							v-model="options.compressLevel"
							:value="85"
							:name="radio0"
							:disabled="!$app.isYsOver || !$app.isDrOver || nowFile.is_gx_quality"
							:class="{disabled_label: nowFile.is_gx_quality}"
						/>
						<label for="qinxi-first"
							><span>{{ $t("clarityfirst") }}</span></label
						>
					</div>
					<div>
						<span class="main-fn-secend-down-main-title">{{ $t("outputformat") }}</span>
						<input
							type="radio"
							id="other-geshi"
							v-model="options.outputExt"
							:value="outputExt"
							:name="radio1"
							:disabled="!$app.isYsOver || !$app.isDrOver"
						/>
						<label for="other-geshi"
							><span>{{ shuchuStyle }}</span></label
						>
						<input
							type="radio"
							id="old-geshi"
							v-model="options.outputExt"
							value=""
							:name="radio1"
							:disabled="!$app.isYsOver || !$app.isDrOver"
						/>
						<label for="old-geshi"
							><span>{{ $t("formatunchang") }}</span></label
						>
					</div>
				</div>
			</div>
			<!-- right -->
			<div
				class="main-fn-secend-down main-fn-secend-down-main"
				:class="{'main-fn-secend-down-img_right-disabled': !$app.VIPlevel && !$app.language}"
				id="main-fn-secend-down-img_right"
			>
				<!-- title -->
				<div class="main-fn-secend-down-img_right-title">
					<p class="main-fn-secend-down-title">{{ $t("efficientcompression") }}</p>
					<input
						type="radio"
						v-model="options.global_application"
						id="global_set_true"
						:value="true"
						name="global_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!options.global_application"
					/>
					<label for="global_set_true" v-show="!options.global_application"
						><span>{{ $t("applytoallfiles") }}</span></label
					>
					<input
						type="radio"
						v-model="options.global_application"
						id="global_set_false"
						:value="false"
						name="global_set"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="options.global_application"
					/>
					<label id="set_false_label" for="global_set_false" v-show="options.global_application"
						><span>{{ $t("applytoallfiles") }}</span></label
					>
					<div
						class="main-fn-secend-down-img_right-title_vip"
						v-if="!$app.VIPlevel && !$app.language"
						@click="
							!$app.VIPlevel && !$app.language
								? [
										toVIP(nowCompressedFormat + '高效压缩限制'),
										gevt(
											'开通VIP即可使用',
											'点击事件',
											nowCompressedFormat,
											'None',
											'None',
											'None'
										),
								  ]
								: null
						"
					>
						<img src="./img/main-fn-body-secend/icon_kt_vip01@2x.png" alt="" />
						<span>{{ $t("openviptouse") }}</span>
					</div>
				</div>
				<!-- 设置按钮 -->
				<div class="main-fn-secend-down-img_right-setbutton_1">
					<p>{{ $t("picturesettings") }}</p>
					<input
						type="radio"
						v-model="nowFile.is_gx_quality"
						:value="true"
						name="quality_set"
						id="quality_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_gx_quality"
					/>
					<label for="quality_set_true" v-show="!nowFile.is_gx_quality"
						><span>{{ $t("definition") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_gx_quality"
						:value="false"
						name="quality_set"
						id="quality_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_gx_quality"
					/>
					<label id="set_false_label" for="quality_set_false" v-show="nowFile.is_gx_quality"
						><span>{{ $t("definition") }}</span></label
					>
					<input
						type="text"
						:value="now_gx_compressLevel"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						@change="gxCopressLevelReturn"
						ref="nowGxCompressLevel"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_quality
						"
					/><span>%</span>
					<!-- 指定输出jpg文件大小 -->
					<input
						type="radio"
						v-model="nowFile.is_gx_filesize"
						:value="true"
						name="filesize_set"
						id="filesize_set_true"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="!nowFile.is_gx_filesize"
					/>
					<label for="filesize_set_true" v-show="!nowFile.is_gx_filesize"
						><span>{{ $t("filesize") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_gx_filesize"
						:value="false"
						name="filesize_set"
						id="filesize_set_false"
						:disabled="!$app.isYsOver || !$app.isDrOver || (!$app.VIPlevel && !$app.language)"
						v-show="nowFile.is_gx_filesize"
					/>
					<label id="set_false_label" for="filesize_set_false" v-show="nowFile.is_gx_filesize"
						><span>{{ $t("filesize") }}</span></label
					>
					<input
						type="text"
						:value="now_gx_filesize"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						@change="gxFileSizeReturn"
						ref="nowGxFileSize"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_filesize
						"
					/><span>kb</span>
					<img
						:class="{
							'main-fn-secend-down-img_right-setbutton_1_img': !(
								!$app.isYsOver ||
								!$app.isDrOver ||
								(!$app.VIPlevel && !$app.language) ||
								!nowFile.is_gx_filesize
							),
						}"
						src="../mycomponents/img/main-fn-body-secend/ico_help@2x.png"
						alt=""
					/>
					<div
						class="main-fn-secend-down-img_right-setbutton_1_img_div"
						:class="{en_language: $app.language}"
					>
						{{ $t("text009") }}
					</div>
				</div>
				<div class="main-fn-secend-down-img_right-setbutton_2">
					<input
						type="radio"
						v-model="nowFile.is_gx_resolution"
						:value="true"
						id="resolution_set_true"
						name="resolution_set"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							nowFile.width == 0
						"
						v-show="!nowFile.is_gx_resolution"
					/>
					<label for="resolution_set_true" v-show="!nowFile.is_gx_resolution"
						><span>{{ $t("resolvingpower") }}</span></label
					>
					<input
						type="radio"
						v-model="nowFile.is_gx_resolution"
						:value="false"
						id="resolution_set_false"
						name="resolution_set"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							nowFile.width == 0
						"
						v-show="nowFile.is_gx_resolution"
					/>
					<label id="set_false_label" for="resolution_set_false" v-show="nowFile.is_gx_resolution"
						><span>{{ $t("resolvingpower") }}</span></label
					>
					<input
						type="text"
						:value="now_gx_width"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxWidthReturn"
						ref="nowGxWidth"
					/><span>x</span
					><input
						type="text"
						:value="now_gx_height"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxHeightReturn"
						ref="nowGxHeight"
					/>
					<p>{{ $t("zoomratio") }}</p>
					<input
						type="text"
						:value="now_gx_aspect_ratio"
						@focus="clear_globalApplication_time(true)"
						@blur="create_globalApplication_time(true)"
						:disabled="
							!$app.isYsOver ||
							!$app.isDrOver ||
							(!$app.VIPlevel && !$app.language) ||
							!nowFile.is_gx_resolution
						"
						@change="gxAaspectRatioReturn"
						ref="nowGxAspectRatio"
					/><span>%</span>
				</div>
			</div>
		</div>
		<inputWarn
			v-if="isshowIw"
			:mess="mess"
			:window_x="window_x"
			:window_y="window_y"
			:level="level"
		></inputWarn>
	</div>
</template>

<script>
import hdapi from "../common/hdapi";
import ShopVue from "../pages/dialogs/Shop.vue";
import LoginVue from "../pages/dialogs/Login.vue";
import InputWarn from "../pages/dialogs/InputWarn.vue";

export default {
	props: {
		imgText: {type: String, required: true}, // 图片名称
		shuchuStyle: {type: String, required: true}, // 输出格式
		files: {type: Array, required: true}, // 文件列表
		options: {type: Object, required: true}, // 配置项
		outputExt: {type: String, required: true}, // 输出格式选项
		isNormalStyle: {type: Boolean, default: false},
		openLimitBody1: {type: Function},
		globalApplication: {type: Function},
		gxSelectArray: {
			type: Object,
			default: function () {
				return {};
			},
		},
		isGlobalApplicationOver: {
			type: Boolean,
		},
		nowCompressedFormat: {
			type: String,
		},
	},
	components: {
		InputWarn,
	},
	data() {
		return {
			radio0: Math.random(),
			radio1: Math.random(),
			nowTr: 0,
			globalApplication_timeout: null,
			window_x: 0,
			window_y: 0,
			isshowIw: false,
			mess: "null",
			closeIw_time: "",
			isFirstClick: false,
			level: 0,
		};
	},
	watch: {
		isglobalApplication(newval, oldval) {
			if (newval) {
				this.create_globalApplication_time(false);
			} else {
				this.clear_globalApplication_time(false);
			}
		},
	},
	computed: {
		isglobalApplication() {
			return this.options.global_application;
		},
		states() {
			return [
				this.$t("filecorruption"),
				this.$t("tobeconvert"),
				this.$t("conversioninprogress"),
				this.$t("outputcomplete"),
				this.$t("switchviews"),
				this.$t("cannotcompress"),
				this.$t("sizelimit"),
			];
		},
		state2tip() {
			return [
				this.$t("text010"),
				this.$t("ready"),
				this.$t("convertingpleasewaitpatient"),
				this.$t("convertnetwork"),
				this.$t("text010"),
				this.$t("text011"),
				this.$t("text012"),
			];
		},
		nowFile() {
			return this.files[this.nowTr];
		},
		now_gx_filesize: {
			get() {
				return Math.floor(this.nowFile.gx_filesize);
			},
			set(newval) {
				var data = this.nowFile;
				if (newval > 0 && newval < data.size / 1024) {
					data.gx_filesize = newval;
				} else {
					console.log("输入格式有问题");
					this.showInputWarn(this.$refs.nowGxFileSize, this.$t("pleaseenteraninteger"), 1);
				}
				this.$refs.nowGxFileSize.value = this.now_gx_filesize;
			},
		},
		now_gx_compressLevel: {
			get() {
				return Math.floor(this.nowFile.gx_compressLevel);
			},
			set(newval) {
				var data = this.nowFile;
				if (newval >= 10 && newval <= 100) {
					data.gx_compressLevel = newval;
				} else {
					console.log("输入格式有问题");
					this.showInputWarn(
						this.$refs.nowGxCompressLevel,
						this.$t("pleaseenteranintegerfrom10to100"),
						2
					);
				}
				this.$refs.nowGxCompressLevel.value = this.now_gx_compressLevel;
			},
		},
		now_gx_width: {
			get() {
				return Math.floor(this.nowFile.gx_width);
			},
			set(newval) {
				var data = this.nowFile;
				if ((newval / data.width) * 100 >= 10 && (newval / data.width) * 100 <= 100) {
					data.gx_width = newval;
					data.gx_aspect_ratio = (data.gx_width / data.width) * 100;
					data.gx_height = (data.height * data.gx_aspect_ratio) / 100;
				} else {
					console.log("输入格式有问题");
					this.showInputWarn(this.$refs.nowGxWidth, this.$t("pleaseenteraninteger"), 1);
				}
				this.$refs.nowGxWidth.value = this.now_gx_width;
			},
		},
		now_gx_height: {
			get() {
				return Math.floor(this.nowFile.gx_height);
			},
			set(newval) {
				var data = this.nowFile;
				if ((newval / data.height) * 100 >= 10 && (newval / data.height) * 100 <= 100) {
					data.gx_height = newval;
					data.gx_aspect_ratio = (data.gx_height / data.height) * 100;
					data.gx_width = (data.width * data.gx_aspect_ratio) / 100;
				} else {
					console.log("输入格式有问题");
					this.showInputWarn(this.$refs.nowGxHeight, this.$t("pleaseenteraninteger"), 1);
				}
				this.$refs.nowGxHeight.value = this.now_gx_height;
			},
		},
		now_gx_aspect_ratio: {
			get() {
				return Math.floor(this.nowFile.gx_aspect_ratio);
			},
			set(newval) {
				var data = this.nowFile;
				if (newval >= 10 && newval <= 100) {
					data.gx_aspect_ratio = newval;
					data.gx_width = (data.width * data.gx_aspect_ratio) / 100;
					data.gx_height = (data.height * data.gx_aspect_ratio) / 100;
				} else {
					console.log("输入格式有问题");
					this.showInputWarn(
						this.$refs.nowGxAspectRatio,
						this.$t("pleaseenteranintegerfrom10to100"),
						2
					);
					// document.addEventListener("click", this.closeInputWarn);
				}
				this.$refs.nowGxAspectRatio.value = this.now_gx_aspect_ratio;
			},
		},
	},
	activated() {
		this.nowTr = 0;
	},
	methods: {
		show(file) {
			hdapi.showItemInfolder(file.outpath, file.path);
		},
		remove(file) {
			this.nowTr = 0;
			this.$emit("remove", file);
		},
		openLimitBody2() {
			this.$emit("openLimitBody1");
		},
		getFileState(e, file, i) {
			this.nowTr = i;
			console.log("当前点击的事件", e, this.nowFile, i);
		},
		toVIP(str) {
			//没登陆用户+非VIP用户
			if (this.$app.isLogin) {
				//登陆成功，判断是否是VIP
				if (!this.$app.VIPlevel) {
					this.gevt("收银台展示量", "收银台事件", str, "None", this.$app.VIPState, "None");
					this.$app.theWayToShop = str;
					//非VIP打开收银台
					this.$dlg.show(ShopVue).then((res) => {
						this.closeLimit();
					});
				} else {
					this.closeLimit();
				}
			} else {
				this.$dlg.show(LoginVue).then((res) => {
					if (this.$app.isLogin) this.toVIP(str);
					else this.closeLimit();
				});
			}
		},
		closeLimit(flag) {
			this.$emit("close", flag);
		},
		create_globalApplication_time(blu) {
			if ((blu && !this.options.global_application) || !this.isGlobalApplicationOver) {
				return;
			} else {
				console.log("定时器已打开");
				this.$emit("globalApplication", this.nowFile);
				this.globalApplication_timeout = setInterval(() => {
					this.$emit("globalApplication", this.nowFile);
				}, 500);
			}
		},
		clear_globalApplication_time(blu) {
			if (!this.globalApplication_timeout && blu) {
				return;
			} else {
				console.log("关闭定时器");
				clearInterval(this.globalApplication_timeout);
			}
		},
		gxFileSizeReturn() {
			this.now_gx_filesize = Number(this.$refs.nowGxFileSize.value);
		},
		gxCopressLevelReturn() {
			this.now_gx_compressLevel = Number(this.$refs.nowGxCompressLevel.value);
		},
		gxWidthReturn() {
			this.now_gx_width = Number(this.$refs.nowGxWidth.value);
		},
		gxHeightReturn() {
			this.now_gx_height = Number(this.$refs.nowGxHeight.value);
		},
		gxAaspectRatioReturn() {
			this.now_gx_aspect_ratio = Number(this.$refs.nowGxAspectRatio.value);
		},
		input(value, x) {
			for (let key in this.nowFile) {
				// console.log(key, this.nowFile[key]);
				if (`${key}` == x) {
					this.nowFile[key] = Number(value);
				}
			}
		},
		gevt(a, b, c, d, e, f) {
			window.gevt(a, b, c, d, e, f);
		},
		showInputWarn(ref, mes, lev) {
			let a = ref.getBoundingClientRect();
			// let b = Number(ref.value);
			this.isshowIw = true;
			this.isFirstClick = true;
			this.level = lev;
			// console.log("2");
			// console.log("ref", ref.getBoundingClientRect());
			this.window_x = a.x;
			this.window_y = a.y + a.height;
			this.mess = mes;
			if (this.closeIw_time) clearTimeout(this.closeIw_time);
			this.closeIw_time = setTimeout(() => {
				let that = this;
				that.isFirstClick = false;
				that.closeInputWarn();
			}, 2000);
		},
		closeInputWarn() {
			// console.log("1");
			if (this.isFirstClick) {
				this.isFirstClick = false;
				return;
			}
			if (this.isshowIw) this.isshowIw = false;
			// document.removeEventListener("click", this.closeInputWarn);
		},
		stateToLimitToShop() {
			this.$app.theWayToShop = this.nowCompressedFormat + "_状态_VIP可压缩";
		},
	},
	mounted() {
		document.addEventListener("click", this.closeInputWarn);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.closeInputWarn);
	},
};
</script>

<style lang="less">
.main-fn-body-secend-body {
	width: 100%;
	height: calc(100% - 46rem);
	/* background-color: thistle; */
	/* padding-top: 35rem; */
	/* padding-left: 35rem; */
	box-sizing: border-box;
	background: #f8f8f8;
}

/* 表格 */
.main-fn-secend-up {
	height: calc(100% - 118rem);
	width: 100%;
	box-sizing: border-box;
	background: #ffffff;
	border-radius: 8rem;
	/* background-color: ; */
}
.main-fn-secend-up-table {
	display: block;
	width: 100%;
	border: none;
	border-collapse: collapse;
	border-spacing: 0;
	/* position: relative; */
}
/* .main-fn-secend-up-table::after { */
/* content: ""; */
/* clear: both; */
/* overflow: hidden; */
/* } */
.main-fn-secend-up-table thead {
	display: block;
	width: 100%;
}
/* 滑动条 */
.main-fn-secend-up-table tbody {
	display: block;
	height: 395rem;
	width: 100%;
	overflow-y: auto;
}
.main-fn-secend-up-table tbody::-webkit-scrollbar {
	width: 7rem;
	height: 100%;
}
.main-fn-secend-up-table tbody::-webkit-scrollbar-button {
	display: none;
}
.main-fn-secend-up-table tbody::-webkit-scrollbar-thumb {
	width: 7rem;
	background: #c5ccd1;
	border-radius: 20rem;
}
.main-fn-secend-up-table tbody::-webkit-scrollbar-track {
	border-radius: 0rem 0rem 20rem 0rem;
}
.main-fn-secend-up-table tbody::-webkit-scrollbar-track-piece {
	background: #edf4f8;
}
/* 字体 */
#main-fn-secend-up-table-th {
	/* height: 36rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei !important;
	/* line-height: 17rem; */
	color: #5c7099 !important;
	/* letter-spacing: 10rem; */
	opacity: 1;
	font-weight: 400;
	border: none;
}
.main-fn-secend-up-table tbody tr td {
	border: none;
}
/* 每一行的样式设计 */
.main-fn-secend-up-table thead tr:nth-of-type(1) {
	height: 35rem !important;
	vertical-align: middle;
	border: none;
	background: #ffffff;
}
.main-fn-secend-up-table tbody tr {
	display: block;
	height: 54rem;
	border: none;
	width: 100% !important;
	/* line-height: 54rem; */
}
.main-fn-secend-up-table tbody tr::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-fn-secend-up-table tbody tr td {
	display: inline-block;
	vertical-align: middle;
	/* height: 54rem; */
}
.main-fn-secend-up-table thead tr {
	display: block;
	width: 100% !important;
	height: 35rem;
	line-height: 35rem;
}
/* !每一列的样式设计 */
.main-fn-secend-up-table tbody tr:nth-of-type(even) {
	background: #ffffff;
}
.main-fn-secend-up-table tbody tr:nth-of-type(odd) {
	background: rgba(232, 243, 255, 0.27);
}
.main-fn-secend-up-table-tr {
	cursor: pointer;
}
.main-fn-secend-up-table-tr-onclick {
	background: rgba(232, 243, 255, 0.9) !important;
}
/* 编号 */
.tr-id {
	text-align: center;
	width: 52rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
/* 文件名称 */
.tr-filename {
	text-align: left;
	width: 140rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
	/* white-space: nowrap; */
	/* overflow: hidden; */
	/* text-overflow: ellipsis; */
}
.tr-filename-state2 {
	padding-left: 23rem;
}
.tr-filename div {
	width: 97rem;
	height: 100%;
	/* overflow: hidden; */
}
.tr-filename div::after {
	content: "";
	height: 54rem;
	display: inline-block;
	vertical-align: middle;
}
.tr-filename div img {
	width: 19rem;
	height: 19rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 7rem;
}
.tr-filename div span {
	display: inline-block;
	vertical-align: middle;
	width: 71rem;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
/* 原文件大小 */
.tr-file-old {
	text-align: left;
	width: 102rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
.tr-file-old-state2 {
	padding-left: 27rem;
}
/* 压缩后大小 */
.tr-file-new {
	text-align: left;
	width: 96rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
.tr-file-new-state2 {
	padding-left: 45rem;
}
/* 原文件分辨率 */
.tr-fen-old {
	text-align: left;
	width: 107rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
/* 压缩后分辨率*/
.tr-fen-new {
	text-align: left;
	width: 117rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
/* 压缩率 */
.tr-yasuolv {
	text-align: left;
	width: 77rem;
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	color: #5c7099;
	opacity: 1;
}
.tr-yasuolv-state2 {
	padding-left: 57rem;
}
/* 状态 */
.tr-zhuangtai {
	text-align: left;
	width: 138rem;
	opacity: 1;
	color: #0f6737;
	font-family: Microsoft YaHei;
	font-size: 12rem;
}
.tr-zhuangtai-state2 {
	padding-left: 49rem;
}

/* 转换成功 */
.tr-zhuangtai-state-success {
	color: #0f6737;
}
/* 转换失败 */
.tr-zhuangtai-state-failure {
	color: rgba(236, 18, 24, 1);
}
.tr-zhuangtai-state-failure::after {
	content: "";
	display: inline-block;
	height: 17.7rem;
	vertical-align: middle;
}
.tr-zhuangtai-state-failure * {
	display: inline-block;
	vertical-align: middle;
}
.tr-zhuangtai-state-failure-div1 {
	position: relative;
	height: 15rem;
	width: 15rem;
	margin-left: 5rem;
	cursor: pointer;
	background-size: cover;
	background-image: url("./img/main-fn-body-secend/icon zt wt01.svg");
}
.tr-zhuangtai-state-failure-div1:hover {
	background-image: url("./img/main-fn-body-secend/icon zt wt02.svg");
}
.tr-zhuangtai-state-failure-div1:hover #tr-zhuangtai-state-failure-downdiv {
	display: block;
}
#tr-zhuangtai-state-failure-downdiv {
	display: none;
	width: 243rem;
	box-sizing: border-box;
	padding: 15rem 6rem 10rem 9rem;
	/* margin-left: 0; */
	/* display: block; */
	position: absolute;
	cursor: pointer;
	transform: translateX(-50%);
	color: rgba(54, 65, 89, 1);
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	line-height: 18rem;
	left: 50%;
	top: 18rem;
	background-size: cover;
	z-index: 99;
	background-image: url("./img/main-fn-body-secend/pic_bg@2x.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
/* 大小限制 */
.tr-zhuangtai-state-limit div {
	display: inline-block;
	width: 92rem;
	height: 21rem;
	background-size: cover;
	cursor: pointer;
	vertical-align: middle;
	background-image: url("./img/main-fn-body-secend/pic_VIPYS_01@2x.png");
}
.tr-zhuangtai-state-limit div:hover {
	background-image: url("./img/main-fn-body-secend/pic_VIPYS_02@2x.png");
}
.tr-zhuangtai-state-limit div:active {
	background-image: url("./img/main-fn-body-secend/pic_VIPYS_03@2x.png");
}
.tr-zhuangtai span {
	white-space: nowrap;
	display: inline-block;
	width: 88rem;
	text-align: center;
}
/* 操作 */
.tr-contral {
	text-align: left;
	width: calc(100% - 829rem);
}
.tr-contral-state2 {
	padding-left: 23rem;
}
.tr-contral-showfile,
.tr-contral-removefile {
	/* border: 1rem solid black; */
	float: left;
	width: 17rem;
	height: 17rem;
	margin-right: 14rem;
	cursor: pointer;
	background: no-repeat;
}
.tr-contral-showfile {
	background-image: url("./img/main-footer/icon cz wjj01.svg");
}
.tr-contral-showfile:hover {
	background-image: url("./img/main-footer/icon cz wjj02.svg");
}
.tr-contral-showfile:active {
	background-image: url("./img/main-footer/icon cz wjj03.svg");
}
.tr-contral-removefile {
	background-image: url("./img/main-footer/icon cz sc01.svg");
}
.tr-contral-removefile:hover {
	background-image: url("./img/main-footer/icon cz sc02.svg");
}
.tr-contral-removefile:active {
	background-image: url("./img/main-footer/icon cz sc03.svg");
}
/* .tr-contral div {
	width: 70%;
}
.tr-contral div img {
	height: 14rem;
	cursor: pointer;
	margin-right: 18rem;
} */

/* 通用设置 */
.main-fn-secend-down {
	margin-top: 16rem;
	width: 100%;
	height: 102rem;
	background: #ffffff;
	opacity: 1;
	border-radius: 8rem;
	box-sizing: border-box;
	padding: 24rem 16rem;
}
.main-fn-secend-down-title {
	font-size: 15rem;
	font-family: MicrosoftYaHei;
	color: #1b212e;
	opacity: 1;
	margin-bottom: 16rem;
}

.main-fn-secend-down-main {
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	color: #5c7099;
	opacity: 1;
}
.main-fn-secend-down-main div {
	display: inline-block;
}
// .main-fn-secend-down-main div:nth-of-type(1) {
// 	margin-right: 128rem;
// }

.main-fn-secend-down-main-title {
	margin-right: 25rem;
}
.main-fn-secend-down-main label span {
	vertical-align: middle;
}
.main-fn-secend-down-main div label:nth-of-type(1) span {
	margin-right: 25rem;
}
.main-fn-secend-down-main label {
	cursor: pointer;
	display: inline-block;
	vertical-align: middle;
	height: 20rem;
	box-sizing: border-box;
}
.normal-first-span {
	margin-right: 25rem;
}
/* 改变radio样式 */
.main-fn-secend-down-main input[type="radio"] {
	position: absolute;
	opacity: 0;
	display: block;
}
.main-fn-secend-down-main input[type="radio"] + label::before {
	content: "";
	width: 15rem;
	height: 15rem;
	display: inline-block;
	vertical-align: middle;
	background-size: cover;
	margin-right: 10rem;
	background-image: url("./img/main-footer/icon_yssz_sx01.svg");
}
// .main-fn-secend-down-main input[type="radio"] + label::after {
// 	content: "";
// 	height: 20rem;
// 	vertical-align: middle;
// 	display: inline-block;
// }
.main-fn-secend-down-main input[type="radio"]:checked + label::before {
	background-image: url("./img/main-footer/icon_scgs_jpj01.svg");
}
// .main-fn-secend-down-main input[type="radio"]:disabled + label::before {
// 	background-image: url("./img/main-footer/icon_yssz_sx02@2x.png");
// }
.main-fn-secend-down-main input[type="radio"]:disabled + label {
	color: rgba(211, 211, 211, 1) !important;
}
#set_false_label::before {
	background-image: url("./img/main-footer/icon_scgs_jpj01.svg");
}
/* img */
// img-left
#main-fn-secend-down-img_left {
	display: inline-block;
	width: 45.44%;
	height: 102rem;
	// overflow: hidden;
	vertical-align: middle;
	margin-right: 1.5%;
	padding: 10rem 0 0 16rem;
	p {
		margin-bottom: 9rem;
	}
	.main-fn-secend-down-main {
		.main-fn-secend-down-main-div1 {
			margin-right: 0;
			margin-bottom: 10rem;
			display: flex;
			align-items: center;
		}
		div {
			display: flex;
			align-items: center;
			.main-fn-secend-down-main-title {
				margin-right: 26rem;
			}
			label {
				margin: 0;
			}
			label span {
				margin-right: 0;
				display: inline-block;
				width: 73rem;
			}
		}
	}
}
// img-right
#main-fn-secend-down-img_right {
	display: inline-block;
	width: 53.05%;
	height: 102rem;
	vertical-align: middle;
	// overflow: hidden;
	padding: 10rem 0 0 16rem;
	background-image: url("./img/main-fn-body-secend/蒙版组 4@2x.png");
	background-size: 212rem 102rem;
	background-position: right bottom;
	background-repeat: no-repeat;
	.main-fn-secend-down-img_right-title {
		margin-right: 0;
		margin-bottom: 10rem;
		display: block;
		p {
			margin-right: 16rem;
			margin-bottom: 0rem;
			display: inline-block;
			vertical-align: middle;
			color: rgba(27, 33, 46, 1) !important;
		}
		label {
			span {
				margin-right: 16rem;
			}
		}

		.main-fn-secend-down-img_right-title_vip {
			display: inline-block;
			vertical-align: middle;
			width: 127rem;
			height: 19rem;
			background: url("./img/main-fn-body-secend/矩形 632@2x.png");
			background-size: cover;
			opacity: 1;
			// border-radius: 5rem;
			box-sizing: border-box;
			padding-left: 7rem;
			margin-right: 0;
			cursor: pointer;
			img {
				display: inline-block;
				vertical-align: middle;
				height: 14rem;
				width: 17rem;
				margin-right: 3rem;
			}
			span {
				display: inline-block;
				vertical-align: middle;
				font-size: 12rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #3e2e09 !important;
				opacity: 1;
			}
			&:hover {
				background: url("./img/main-fn-body-secend/矩形 632@2x(1).png");
				background-size: cover;
			}
			&:active {
				background: url("./img/main-fn-body-secend/矩形 632@2x(2).png");
				background-size: cover;
			}
			&::after {
				content: "";
				display: inline-block;
				height: 100%;
				vertical-align: middle;
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	.main-fn-secend-down-img_right-setbutton_1 {
		margin-right: 0;
		margin-bottom: 8rem;
		display: block;
		position: relative;
		p {
			display: inline-block;
			vertical-align: middle;
			width: 60rem;
			margin-right: 16rem;
		}
		input[type="radio"] + label span {
			margin-right: 24rem;
		}

		input[type="text"] + span {
			display: inline-block;
			vertical-align: middle;
			font-size: 12rem;
			font-family: MicrosoftYaHei;
			// color: rgba(118, 142, 190, 1);
			opacity: 1;
			&:nth-of-type(1) {
				margin-right: 52rem;
			}
		}
		img {
			display: inline-block;
			width: 16rem;
			vertical-align: middle;
			height: 16rem;
			margin-left: 8rem;
			cursor: pointer;
		}
		.main-fn-secend-down-img_right-setbutton_1_img {
			// z-index: 99999;
			&:hover + .main-fn-secend-down-img_right-setbutton_1_img_div {
				display: block;
			}
		}
		.main-fn-secend-down-img_right-setbutton_1_img_div {
			position: absolute;
			display: none;
			width: 142rem;
			margin-right: 0;
			font-size: 12rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #5c7099;
			opacity: 1;
			right: -17rem;
			bottom: 3rem;
			left: 326rem;
			background-image: url("../mycomponents/img/main-fn-body-secend/shape_bg@2x.png");
			width: 166rem;
			background-size: cover;
			padding: 12rem 12rem 35rem;
			box-sizing: border-box;
			z-index: 99998;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			&.en_language {
				right: 16rem;
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	.main-fn-secend-down-img_right-setbutton_2 {
		input[type="radio"] + label {
			margin-left: 76rem;
			span {
				margin-right: 24rem;
			}
		}
		input[type="text"] + span {
			margin-right: 8rem;
			vertical-align: middle;
			font-size: 12rem;
			font-family: MicrosoftYaHei;
			// color: #d3d3d3;
			opacity: 1;
		}
		p {
			display: inline-block;
			vertical-align: middle;
			margin-left: 32rem;
			margin-right: 26rem;
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	input[type="text"] {
		width: 42rem;
		height: 20rem;
		border: 1rem solid #d3d3d3;
		opacity: 1;
		border-radius: 2rem;
		display: inline-block;
		vertical-align: middle;
		text-align: center;
		font-size: 12rem;
		font-family: Arial;
		font-weight: 400;
		color: rgba(118, 142, 190, 1);
		// letter-spacing: 10rem;
		opacity: 1;
		outline: none;
		margin-right: 8rem;
		box-sizing: border-box;
		&:focus {
			border: 1rem solid #006de0;
			// border: none;
		}
		&:disabled {
			color: rgba(211, 211, 211, 1) !important;
		}
	}
	input[type="radio"] + label {
		&::before {
			margin-right: 8rem;
		}
	}
}
// img-disabled
.main-fn-secend-down-img_right-disabled {
	* {
		color: rgba(211, 211, 211, 1) !important;
		cursor: pointer;
	}
	background-image: none !important;
}
/*video */
#main-fn-secend-down-video_left {
	display: inline-block;
	height: 149rem;
	width: 36.87%;
	// overflow: hidden;
	margin-right: 1.5%;
	padding: 10rem 0 0 16rem;
	vertical-align: middle;
	// box-sizing: border-box;
	p {
		margin-bottom: 9rem;
	}
	.main-fn-secend-down-main {
		.main-fn-secend-down-main-div1 {
			margin-right: 0;
			margin-bottom: 10rem;
			display: flex;
			align-items: center;
		}
		div {
			display: flex;
			align-items: center;
			.main-fn-secend-down-main-title {
				margin-right: 26rem;
			}
			label {
				margin: 0;
			}
			label span {
				margin-right: 0;
				display: inline-block;
				width: 73rem;
			}
		}
	}
}
// video-right
#main-fn-secend-down-video_right {
	display: inline-block;
	width: 61.52%;
	height: 149rem;
	// overflow: hidden;
	vertical-align: middle;
	padding: 10rem 0 0 16rem;
	background-image: url("./img/main-fn-body-secend/蒙版组 11@2x.png");
	background-size: 212rem 149rem;
	background-position: right bottom;
	background-repeat: no-repeat;
	.main-fn-secend-down-video_right-title {
		margin-right: 0;
		margin-bottom: 17rem;
		display: block;
		p {
			margin-right: 17rem;
			margin-bottom: 0rem;
			display: inline-block;
			vertical-align: middle;
			color: rgba(27, 33, 46, 1) !important;
		}
		label {
			span {
				margin-right: 16rem;
			}
		}

		.main-fn-secend-down-video_right-title_vip {
			display: inline-block;
			vertical-align: middle;
			width: 127rem;
			height: 19rem;
			background: url("./img/main-fn-body-secend/矩形 632@2x.png");
			background-size: cover;
			opacity: 1;
			// border-radius: 5rem;
			box-sizing: border-box;
			padding-left: 7rem;
			margin-right: 0;
			cursor: pointer;
			img {
				display: inline-block;
				vertical-align: middle;
				height: 14rem;
				width: 17rem;
				margin-right: 3rem;
			}
			span {
				display: inline-block;
				vertical-align: middle;
				font-size: 12rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #3e2e09 !important;
				opacity: 1;
			}
			&:hover {
				background: url("./img/main-fn-body-secend/矩形 632@2x(1).png");
				background-size: cover;
			}
			&:active {
				background: url("./img/main-fn-body-secend/矩形 632@2x(2).png");
				background-size: cover;
			}
			&::after {
				content: "";
				display: inline-block;
				height: 100%;
				vertical-align: middle;
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	.main-fn-secend-down-video_right-setbutton_1 {
		display: block;
		margin-bottom: 13rem;
		input[type="radio"] + label {
			// margin-left: 76rem;
			span {
				margin-right: 24rem;
			}
		}
		input[type="text"] {
			+ span {
				margin-right: 8rem;
				vertical-align: middle;
				font-size: 14rem;
				font-family: MicrosoftYaHei;
				// color: #d3d3d3;
				opacity: 1;
				&:nth-of-type(1) {
					margin-right: 42rem;
				}
			}
		}
		p {
			display: inline-block;
			vertical-align: middle;
			&:nth-of-type(1) {
				width: 60rem;
				height: 16rem;
				margin-right: 17rem;
			}
			&:nth-of-type(2) {
				margin-right: 19rem;
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	.main-fn-secend-down-video_right-setbutton_2 {
		display: block;
		margin-bottom: 13rem;
		label {
			> span {
				margin: 0;
				margin-right: 24rem;
			}
			&:nth-of-type(1),
			&:nth-of-type(2) {
				margin-left: 77rem;
			}
		}
		.i-select {
			display: inline-block;
			vertical-align: middle;
			height: 20rem;
			&:nth-of-type(1) {
				margin-right: 29rem;
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	.main-fn-secend-down-video_right-setbutton_3 {
		display: block;
		p {
			display: inline-block;
			vertical-align: middle;
			&:nth-of-type(1) {
				width: 60rem;
				height: 16rem;
				margin-right: 17rem;
			}
		}
		label {
			> span {
				margin: 0;
				margin-right: 24rem;
			}
			&:nth-of-type(3),
			&:nth-of-type(4) {
				span {
					margin-right: 9rem;
				}
			}
		}
		.i-select {
			display: inline-block;
			vertical-align: middle;
			height: 20rem;
			&:nth-of-type(1) {
				margin-right: 29rem;
				.option {
					div {
						text-align: left;
						padding-left: 15rem;
					}
				}
			}
		}
		&::after {
			content: "";
			height: 20rem;
			vertical-align: middle;
			display: inline-block;
		}
	}
	input[type="text"] {
		width: 42rem;
		height: 20rem;
		border: 1rem solid #d3d3d3;
		opacity: 1;
		border-radius: 2rem;
		display: inline-block;
		vertical-align: middle;
		text-align: center;
		font-size: 12rem;
		font-family: Arial;
		font-weight: 400;
		color: rgba(118, 142, 190, 1);
		// letter-spacing: 10rem;
		opacity: 1;
		outline: none;
		margin-right: 8rem;
		box-sizing: border-box;
		&:focus {
			border: 1rem solid #006de0;
			// border: none;
		}
		&:disabled {
			color: rgba(211, 211, 211, 1) !important;
		}
	}
	input[type="radio"] + label {
		&::before {
			margin-right: 8rem;
		}
	}
}
// video-disabled
.main-fn-secend-down-video_right-disabled {
	* {
		color: rgba(211, 211, 211, 1) !important;
		cursor: pointer;
	}
	background-image: none !important;
}

.disabled_label + label::before {
	background-image: url("./img/main-footer/icon_yssz_sx02@2x.png") !important;
}
.main-fn-secend-up-spys {
	height: calc(100% - 165rem);
}
.main-fn-secend-up-table {
	height: 100%;
	tbody {
		height: calc(100% - 35rem);
	}
}

// 响应式布局
.tbody_Full-secreen {
	tr {
		.tr-id {
			width: 7.27%;
		}
		.tr-filename {
			width: 12.98%;
		}
		.tr-file-old {
			width: 11.36%;
		}
		.tr-file-new {
			width: 10.27%;
		}
		.tr-fen-old {
			width: 11.05%;
		}
		.tr-fen-new {
			width: 11.93%;
		}
		.tr-yasuolv {
			width: 9.24%;
		}
		.tr-zhuangtai {
			width: 9.62%;
		}
		.tr-contral {
			width: 6.65%;
		}
	}
}
.thead_Full-secreen {
	display: block;
	tr {
		display: block;
		th {
			display: inline-block;
		}
		.tr-id {
			width: 7.27%;
		}
		.tr-filename {
			width: 12.98%;
		}
		.tr-file-old {
			width: 11.36%;
		}
		.tr-file-new {
			width: 10.27%;
		}
		.tr-fen-old {
			width: 11.05%;
		}
		.tr-fen-new {
			width: 11.93%;
		}
		.tr-yasuolv {
			width: 9.24%;
		}
		.tr-zhuangtai {
			width: 9.62%;
		}
		.tr-contral {
			width: 6.65%;
		}
	}
}

@media screen and (max-height: 636px) {
	.main-fn-body-secend-body * {
		font-size: 14.16rem !important;
	}
	.main-fn-secend-down-img_right-title_vip,
	.main-fn-secend-down-video_right-title_vip {
		span {
			font-size: 12rem !important;
		}
	}
	#main-fn-secend-down-img_right .main-fn-secend-down-img_right-setbutton_1 p {
		width: auto;
		margin-right: 2rem;
		height: 20rem;
	}
	#main-fn-secend-down-img_right
		.main-fn-secend-down-img_right-setbutton_2
		input[type="radio"]
		+ label {
		margin-left: 73rem;
	}
	#main-fn-secend-down-video_right .main-fn-secend-down-video_right-setbutton_1 p:nth-of-type(1) {
		width: auto;
		height: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-video_right .main-fn-secend-down-video_right-setbutton_3 p:nth-of-type(1) {
		width: auto;
		margin-right: 6rem;
		height: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-img_right
		.main-fn-secend-down-img_right-setbutton_1
		.main-fn-secend-down-img_right-setbutton_1_img_div {
		font-size: 12rem !important;
	}
	#main-fn-secend-down-img_right
		.main-fn-secend-down-img_right-setbutton_1
		input[type="text"]
		+ span:nth-of-type(1) {
		margin-right: 47rem;
	}
	.main-fn-secend-down-main label {
		line-height: 100%;
	}
	#main-fn-secend-down-img_right .main-fn-secend-down-img_right-setbutton_2 p {
		height: 20rem;
	}
	#main-fn-secend-down-img_left .main-fn-secend-down-main div .main-fn-secend-down-main-title {
		height: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-video_left .main-fn-secend-down-main div .main-fn-secend-down-main-title {
		height: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-img_right .main-fn-secend-down-img_right-title p {
		height: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-video_right .main-fn-secend-down-video_right-title p {
		height: 20rem;
		margin-right: 20rem;
		line-height: 100%;
	}
	#main-fn-secend-down-video_right
		.main-fn-secend-down-video_right-title
		.main-fn-secend-down-video_right-title_vip {
		line-height: 100%;
	}
	#main-fn-secend-down-img_right
		.main-fn-secend-down-img_right-title
		.main-fn-secend-down-img_right-title_vip {
		line-height: 100%;
	}
}

// en
.main-fn-body-secend-body_en {
	.main-fn-secend-down-video_en {
		#main-fn-secend-down-video_left {
			.main-fn-secend-down-main {
				div {
					.main-fn-secend-down-main-title {
						margin-right: 10rem;
						width: 89rem;
						text-align: right;
					}
				}
				label {
					display: flex;
					align-items: center;
				}
			}
		}
		#main-fn-secend-down-video_right {
			.main-fn-secend-down-video_right-setbutton_1 {
				display: flex;
				p {
					&:nth-of-type(1) {
						width: 60rem;
						margin-right: 10rem;
					}
					&:nth-of-type(2) {
						margin-left: 60rem;
						margin-right: 10rem;
					}
				}
				input[type="radio"] + label {
					span {
						width: 50rem;
						margin-right: 10rem;
						text-align: right;
					}
				}
			}
			.main-fn-secend-down-video_right-setbutton_2 {
				display: flex;

				input[type="radio"] + label {
					&:nth-of-type(1),
					&:nth-of-type(2) {
						margin-left: 70rem;
						span {
							width: 50rem;
						}
					}
					&:nth-of-type(3),
					&:nth-of-type(4) {
						span {
							width: 80rem;
						}
					}
				}
			}
			.main-fn-secend-down-video_right-setbutton_3 {
				display: flex;
				input[type="radio"] + label {
					&:nth-of-type(1),
					&:nth-of-type(2) {
						span {
							width: 50rem;
						}
					}
					&:nth-of-type(3),
					&:nth-of-type(4) {
						span {
							width: 80rem;
						}
					}
				}
				p {
					&:nth-of-type(1) {
						width: 60rem;
						margin-right: 10rem;
					}
				}
			}
			input[type="radio"] + label {
				display: inline-flex;
				align-items: center;
				span {
					margin-right: 10rem;
					text-align: right;
				}
			}
		}
	}
	.main-fn-secend-down-img_en {
		#main-fn-secend-down-img_left {
			.main-fn-secend-down-main {
				div {
					.main-fn-secend-down-main-title {
						margin-right: 10rem;
						width: 89rem;
						text-align: right;
					}
				}
				label {
					display: flex;
					align-items: center;
				}
			}
		}
		#main-fn-secend-down-img_right {
			.main-fn-secend-down-img_right-setbutton_1 {
				display: flex;
				// align-items: center;
				p {
					&:nth-of-type(1) {
						width: 60rem;
						margin-right: 0rem;
					}
				}
				input[type="radio"] + label {
					&:nth-of-type(1),
					&:nth-of-type(2) {
						span {
							width: 70rem;
						}
					}
					&:nth-of-type(3),
					&:nth-of-type(4) {
						span {
							width: 60rem;
						}
					}
				}
			}
			.main-fn-secend-down-img_right-setbutton_2 {
				display: flex;
				// align-items: center;
				input[type="radio"] + label {
					&:nth-of-type(1),
					&:nth-of-type(2) {
						margin-left: 60rem;
						span {
							width: 70rem;
						}
					}
				}
				p {
					margin-right: 10rem;
					margin-left: 35rem;
				}
			}
			input[type="radio"] + label {
				display: inline-flex;
				align-items: center;
				span {
					margin-right: 10rem;
					text-align: right;
				}
			}
		}
	}
}
</style>
